<template>
  <div>
    <h4><vs-icon class="material-icons" icon="fingerprint"></vs-icon> Firmas Digitales</h4>
    <div v-if="!signatures || signatures.length === 0">
      <vs-icon
        icon="info"
        class="material-icons"
        style="color: orange; cursor: default"
      >
      </vs-icon>
      Este documento no ha sido firmado digitalmente.
    </div>
    <div
      v-show="signatures && signatures.length > 0"
      v-for="(approver, index) in signatures"
      v-bind:key="index"
    >
      <div class="aprobaciones d-flex justify-content-between">
        <div class="d-flex flex-row">
          <div class="numero">{{ index + 1 }}</div>
          <div class="d-flex flex-column">
            <div class="nombre">{{ approver.nombreUsuario }}</div>
            <div class="correo">{{ approver.correoUsuario }}</div>
          </div>
        </div>
        <div class="d-flex flex-column justify-content-between align-items-end">
          <div class="proveedor cursor">
            <vs-tooltip
              position="top"
              text="Proveedor de Firma"
            >
              <span class="badge badge-primary">
                {{ signatureProvider(approver.proveedorFirma) }}
              </span>
            </vs-tooltip>
          </div>
          <div
            class="fecha"
            title="Fecha de Firma"
            v-if="approver.fecha"
          >
            {{ approver.fecha.replace(" ", " a las ") }} hrs.
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div v-if="url" class="text-center">
      <a class="btn btn-warning" :href="url" target="_blank">Ver documento</a>
    </div>
  </div>
</template>

<script>
import signatures from '@/febos/chile/verificarQrAprobaciones/mixins/signatures';

export default {
  name: 'DigitalSignatures',
  props: ['signatures', 'url'],
  data() {
    return {
      simpleSignature: signatures.simpleSignature,
      advancedSignature: signatures.advancedSignature
    };
  },
  methods: {
    signatureProvider(proveedor) {
      this.simpleSignature.forEach((fs) => {
        let name = null;
        if (fs.if === proveedor) {
          name = fs.name;
        }
        return name;
      });
      this.advancedSignature.forEach((fs) => {
        let name = null;
        if (fs.if === proveedor) {
          name = fs.name;
        }
        return name;
      });
      return proveedor;
    }
  }
};
</script>

<style scoped>
.btn-warnign {
  color: #ffa000;
}
.proveedor {
  position: relative;
  float: right;
  top: 0;
  right: 0;
}
.fecha {
  font-size: 80%;
  color: #333;
}
.cursor {
  cursor: default;
}
</style>
